"use client"
import SpandaDAT from "@/components/Product1/SpandaDAT";
import Breadcrumb from "@/components/Common/Breadcrumb";
import React, { useState, useEffect } from "react";

const Productpage = () => {

	const [isMobile, setIsMobile] = useState(false);
	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 600);
		};

		// Initialize the isMobile state
		handleResize();

		// Add resize event listener
		window.addEventListener("resize", handleResize);

		// Clean up event listener on component unmount
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return (
		<>
			<Breadcrumb pageName="" />
			<SpandaDAT isMobile={isMobile}/>
		</>
	);
};

export default Productpage;
